import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTO.ts';
import {
  getFrontTipiDomanda,
  getGetFrontTipiDomandaQueryOptions,
} from '@framework/api-client/api/inquiries-compile/tipi-domanda/tipi-domanda.ts';
import { createAsyncSelectChipValue } from '@framework/form/inputs/AsyncSelectChipValue.tsx';
import {
  AsyncSelectInput,
  type IBaseAsyncSelectInputProps,
} from '@framework/form/inputs/AsyncSelectInput.tsx';

export interface IInquiryTypeSelectInputProps
  extends IBaseAsyncSelectInputProps {}

export function InquiryTypeSelectInput(props: IInquiryTypeSelectInputProps) {
  const { ...otherProps } = props;
  return (
    <AsyncSelectInput
      {...otherProps}
      queryFn={getFrontTipiDomanda}
      initialParams={{ ordinamenti: ['titolo'] }}
      queryOptions={getGetFrontTipiDomandaQueryOptions}
      searchByField="titolo"
      asOption={(inquiryType: TipoDomandaDTO) => ({
        value: inquiryType.idGruppo!,
        label: inquiryType.titolo!,
      })}
    />
  );
}

/**
 * `renderValue` per il chip FilterBar: risolve l'id gruppo del tipo domanda nel
 * titolo. La lista (ordinata per titolo) è caricata interamente → nessuna
 * ricerca per valore necessaria.
 */
export const inquiryTypeChipValue = createAsyncSelectChipValue({
  queryFn: getFrontTipiDomanda,
  queryOptions: getGetFrontTipiDomandaQueryOptions,
  initialParams: { ordinamenti: ['titolo'] },
  asOption: (inquiryType: TipoDomandaDTO) => ({
    value: inquiryType.idGruppo!,
    label: inquiryType.titolo!,
  }),
});
